package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.state.Stateful
import ai.flowstorm.common.state.StatefulValue
import ai.flowstorm.common.ui.Form
import ai.flowstorm.common.ui.UiHelpers
import ai.flowstorm.studio.model.ProfileRecord
import ai.flowstorm.studio.model.User
import ai.flowstorm.studio.resources.space.ProfileRecordResource
import io.kvision.core.Clear
import io.kvision.core.Component
import io.kvision.core.PosFloat
import io.kvision.form.text.Text
import io.kvision.html.button
import io.kvision.i18n.tr
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import io.kvision.state.observableListOf
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable

class ProfileRecordUserSearchForm(private val viewer: ProfileRecordUserViewer) :
    Form<ProfileRecordUserSearchForm.FormData>(FormData.serializer()),
    Stateful<ProfileRecordUserSearchForm.State> by StatefulValue(State())
{
    private lateinit var entity: User

    @Serializable
    data class FormData (
        val search: String? = null,
    )

    data class State (
        val loading: Boolean = false,
        val data: List<ProfileRecord> = listOf(),
        val formData: FormData = FormData()
    )

    init {
        marginTop = UiHelpers.spacing
        marginRight = UiHelpers.spacing
        add (
            FormData::search,
            Text(label = tr("Search text (if empty, will list all records)"), ),
        )
        add (
            simplePanel {
                float = PosFloat.RIGHT
                button(tr("Extract")).bind(this@ProfileRecordUserSearchForm) {
                    disabled = it.loading
                    text = if (it.loading) tr("Extracting ...") else tr("Extract")
                }.onClick {
                    search(getData())
                }
            }
        )
        simplePanel {
            clear = Clear.BOTH
        }
    }

    private fun search(data: FormData) {
        val query = ProfileRecordResource.buildQuery(entity, data)
        val profileRecords = observableListOf<ProfileRecord>()
        mainScope.launch {
            profileRecords.addAll(ProfileRecordResource(entity).load(query))
        }

        viewer.loadRecords(profileRecords)
    }

    fun load(entity: User): Component {
        this.entity = entity
        return this
    }
}
